import {
  CreatedUserApiData,
  UserByLoginData,
  UserData,
  UsersResponse,
} from "../entities/Users";

// Shape brut API éventuel si différent du domaine
// interface ApiRole {
//   id: string;
//   name: string;
// }
// interface ApiBranch {
//   id: number;
//   code: string;
//   designation: string;
//   description: string;
// }

export class UserDataMapper {
  /**
   * Transforms API response to domain model with pagination
   */
  static toDomainModel(apiResponse: UsersResponse): UserData[] {
    return (apiResponse.data.items || []).map((userData: UserData) => ({
      id: userData.id ?? null,
      login: userData.login ?? null,
      firstName: userData.firstName ?? null,
      lastName: userData.lastName ?? null,
      email: userData.email ?? null,
      roles: userData.roles ?? [],
      branch: userData.branch ?? null,
      valid: userData.valid ?? null,
      isActivate: userData.isActivate ?? null,
      activationDate: userData.activationDate ?? null,
      expirationDate: userData.expirationDate ?? null,
      createdTimestamp: userData.createdTimestamp ?? null,
      backup: userData.backup ?? null,
      numberPhone: userData.numberPhone ?? null,
      presence: userData.presence ?? null,
    }));
  }

  /**
   * Transforms API response to domain model with pagination
   */
  // static toDomainModelPageable(apiResponse: UsersResponse): UsersResponse {
  //   return {
  //     code: apiResponse.code,
  //     message: apiResponse.message,
  //     data: apiResponse.data,
  //     totalPages: apiResponse.data.length,
  //     totalElements: apiResponse.data.length,
  //     pageable: {
  //       pageNumber: 1,
  //       pageSize: apiResponse.data.length,
  //       sort: [],
  //       offset: 0,
  //       paged: true,
  //       unpaged: false,
  //     },
  //     size: apiResponse.data.length,
  //     content: apiResponse.data,
  //     number: 1,
  //     sort: [],
  //     first: true,
  //     last: true,
  //     numberOfElements: apiResponse.data.length,
  //     empty: false,
  //   };
  // }

  /**
   * Transforms domain model back to API request format
   */
  static toApiRequest(domainModel: Partial<UserData>): Partial<UserData> {
    // This method can be used if you need to transform domain filters back to API format
    // For now, returning the domain model as-is since the API request structure matches
    return domainModel;
  }

  static fromCreatedUserApiToUserData(data: CreatedUserApiData): UserData {
    return {
      id: data.id ?? null,
      login: data.login ?? null,
      firstName: data.firstName ?? null,
      lastName: data.lastName ?? null,
      email: data.email ?? null,
      roles: data.roles ?? [],
      branch: data.branch ?? null,
      valid: null,
      isActivate: data.isActivate ?? null,
      activationDate: null,
      expirationDate: null,
      createdTimestamp: data.createdTimestamp ?? null,
      backup: null,
      numberPhone: data.numberPhone ?? null,
      presence: null,
    };
  }

  static fromUserByLoginToUserData(user: UserByLoginData): UserData {
    return {
      id: user.id ?? null,
      login: user.matricule ?? null,
      firstName: user.firstName ?? null,
      lastName: user.lastName ?? null,
      email: user.email ?? null,
      roles: user.roles ?? [],
      branch: user.branch ?? null,
      valid: true,
      isActivate: true,
      activationDate: null,
      expirationDate: null,
      createdTimestamp: null,
      backup: null,
      numberPhone: user.numberPhone ?? null,
      presence: null,
    };
  }
}
